import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { AuthGuard } from '@/auth/guard';
import { SplashScreen, LoadingScreen } from '@/components/feedback/loading-screen';
import DashboardLayout from '@/layouts/management';
import { DashboardPage } from './imports';

export const mainDashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<SplashScreen bgcolor={'transparent'} />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <DashboardPage />, index: true },
    ],
  },
];
